exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "*{margin:0;padding:0}body{color:#2c303d;background:#f6f6f6;font-family:Open Sans,arial}.container,.container_flex{margin:0 auto;width:100%;max-width:835px;min-width:400px;padding:30px 50px}.container_flex{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}a{text-decoration:none;outline:none}ul{list-style:none}@media only screen and (max-width:935px){.container,.container_flex{max-width:640px;padding:30px 35px}}@media only screen and (max-width:730px){.container,.container_flex{max-width:400px;padding:30px 0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3e43f94b","scoped":false,"hasInlineConfig":false}!./~/autoprefixer-loader!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 24
// module chunks = 0